import {Route, Routes, Navigate} from 'react-router-dom';
import {useAuth} from './auth/AuthContext';
import {ThemeProvider} from './contexts/ThemeContext';
import {ClickableProvider} from './providers/ClickableProvider';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AnimePage from "./pages/AnimePage";
import AnimeListPage from "./pages/AnimeListPage";
import UserListPage from "./pages/UserListPage";
import UserProfilePage from "./pages/UserProfilePage";
import FriendsPage from "./pages/FriendsPage";

import './styles/Theme.css';

function ProtectedRoute({children}: { children: React.ReactNode }) {
    const {isAuthenticated} = useAuth();
    return isAuthenticated ? <>{children}</> : <Navigate to="/"/>;
}

const App: React.FC = () => {
    return (
        <ThemeProvider>
            <ClickableProvider>
                <Layout>
                    <Routes>
                        <Route path="/" element={<HomePage/>}/>
                        <Route path="/anime" element={<AnimeListPage/>}/>
                        <Route path="/anime/:id" element={<AnimePage/>}/>
                        <Route path="/profile" element={
                            <ProtectedRoute>
                                <UserProfilePage/>
                            </ProtectedRoute>
                        }/>
                        <Route path="/users/:nickname" element={<UserProfilePage/>}/>
                        <Route path="/users/:nickname/list" element={<UserListPage/>}/>
                        <Route path="/my-list" element={
                            <ProtectedRoute>
                                <UserListPage/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/friends" element={
                            <ProtectedRoute>
                                <FriendsPage/>
                            </ProtectedRoute>
                        }/>
                        <Route path="/followers" element={
                            <ProtectedRoute>
                                <FriendsPage/>
                            </ProtectedRoute>
                        }/>
                        <Route path="/following" element={
                            <ProtectedRoute>
                                <FriendsPage/>
                            </ProtectedRoute>
                        }/>

                        {/* Для чужого профиля */}
                        <Route path="/users/:nickname/friends" element={<FriendsPage/>}/>
                        <Route path="/users/:nickname/followers" element={<FriendsPage/>}/>
                        <Route path="/users/:nickname/following" element={<FriendsPage/>}/>

                        {/* Альтернативные маршруты */}
                        <Route path="/profile/friends" element={
                            <ProtectedRoute>
                                <FriendsPage/>
                            </ProtectedRoute>
                        }/>
                        <Route path="/profile/followers" element={
                            <ProtectedRoute>
                                <FriendsPage/>
                            </ProtectedRoute>
                        }/>
                        <Route path="/profile/following" element={
                            <ProtectedRoute>
                                <FriendsPage/>
                            </ProtectedRoute>
                        }/>

                        {/* Redirects для старых маршрутов */}
                        <Route path="/login" element={<Navigate to="/"/>}/>
                    </Routes>
                </Layout>
            </ClickableProvider>
        </ThemeProvider>
    );
};

export default App;